// extracted by mini-css-extract-plugin
export default {"error404":"Error404_error404__Gs-jQ","wrapper":"Error404_wrapper__9XI5G"};